<template>
  <router-view />
</template>

<script setup lang="ts">
</script>

<style lang="scss">
@import "@/assets/fonts/fonts.css";
@import "@/assets/fonts/stylesheet.css";
* { margin: 0; padding: 0; box-sizing: border-box;}
html, body { width: 100%; height: 100%; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; background: #f5f5f5; line-height: 1.6;}
#app { width: 100%; height: 100%; font-size: 0.48rem;}
img{ display: block; width: 100%; vertical-align: middle;}

.over { overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
.over2 { display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 2;}
.disFlex{ display: flex; justify-content: space-between; align-items: center;}
.disFlexc{ display: flex; justify-content: center; align-items: center;}
.disFlexs{ display: flex; flex-direction: column; justify-content: center; align-items: center;}

/* 页面背景色 */
.bg-f1f4f9{ background: #f1f4f9;}

/* 内容宽度 */
.wrap{ padding: 0 1rem; box-sizing: border-box;}
/* 文字渐变 */
.textlinear { -webkit-background-clip: text; color: transparent; display: inline-block;}

/* 顶部导航 */
.page-rt { position: fixed; top: 0; left: 0; z-index: 10; width: 100%; height: 1.96rem; border-bottom: 1px solid rgba(170,182,209,0.4);}
.page-rt h1 { font-size: 0.68rem; color: #333;}
.page-rt .back { position: absolute; left: 0.7rem; top: 0; z-index: 10; width: 1rem; height: 100%; margin-right: 0.2rem;}
.page-rt .back img{ width: 0.4rem; height: auto;}
.toph{ height: 1.98rem;}
</style>
